
import { Sounds } from '../../../@resources/sounds';
import { telemetry } from '../../../@vendor/Posthog';
import { Arr } from '../../../CodesForFoundation';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { resolveSubject } from '../../canvas/commands/CommandUtil';
import { Physicals } from '../../canvas/entities/Physicals';
import { BuzzController } from './BuzzController';
import { Buzzer } from './Buzzer';

export const createBuzzer = defineCommand(
    'createBuzzer',
    'Create: Buzzer...',
    (cc) => {
        Physicals.createAtCameraPosition(cc, Buzzer, x => {
            x.width = 140;
            x.height = 140;
            x.sound = Arr.random([
                Sounds.Buzzer1,
                Sounds.Buzzer2,
                Sounds.Buzzer3,
                Sounds.Buzzer4,
                Sounds.Buzzer5,
            ]);
        });
    },
);

export const buzzerSpin = defineCommand(
    'buzzerSpin',
    'Buzzer: Spin',
    (cc, [targetId]: [string]) => {

        const ctrl = cc.resolve(BuzzController);
        const buzzer = resolveSubject(cc, targetId)?.as(Buzzer);
        if (!buzzer) return;

        ctrl.buzz(buzzer);
        telemetry.emit('interaction.buzzer', {
            sound: buzzer.sound,
        });
    }
);

export const inBuzzerCommands = () => inCommands(
    createBuzzer,
    buzzerSpin,
);

